/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Lot_Picker_SearchInputs */

const vi_pl_lot_picker_search = /** @type {(inputs: Pl_Lot_Picker_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm mã lô, đơn mua hoặc hộ bán...`)
};

/**

* @param {Pl_Lot_Picker_SearchInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_lot_picker_search = /** @type {((inputs?: Pl_Lot_Picker_SearchInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Lot_Picker_SearchInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_lot_picker_search(inputs)
});